import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { kommendeLesen, type KommendeInfo } from "@/lib/termine/infoveranstaltungen";

// Kommende Infoveranstaltungen für Terminseiten, Startseite, /links und die neue Ansicht (Sitzung 14b). Gelesen nur über
// `marketing_info_kommende()` (für Besucher:innen offen, nur die gezeigten Felder); die Tabellen bleiben zu. Ein Fehler
// kostet nur die Karten der Infoveranstaltungen, nie die Termine.

const LEER: KommendeInfo[] = [];

export async function kommendeInfosLaden(grenze = 20): Promise<KommendeInfo[]> {
  const { data, error } = await supabase.rpc("marketing_info_kommende", { p_grenze: grenze });
  if (error) throw error;
  return kommendeLesen(data);
}

/** Kommende Infoveranstaltungen (Thema live, nicht abgesagt), ohne Antwort eine leere Liste. */
export function useKommendeInfoveranstaltungen(aktiv = true): KommendeInfo[] {
  const q = useQuery({
    queryKey: ["infoveranstaltungen-kommend"],
    queryFn: () => kommendeInfosLaden(),
    staleTime: 5 * 60 * 1000,
    retry: false,
    enabled: aktiv,
  });
  return q.data ?? LEER;
}
